import React, { useCallback, useContext, useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import { PaymentTypes, PaymentTypesType } from 'services/api/PaymentApi/types/common'

import { MODAL_ROUTE_URLS } from 'router/modalRoutes'

import { ReactComponent as LogoSVG } from 'shared/img/logo.svg'

import { selectIsUserAuthenticated } from 'features/auth/selectors'
import { selectLocaleDict } from 'features/locale/selectors'

import { useModalContext } from '@bcraft-frontend-lib/core'

import './PaymentModalWrapper.scss'

const b = block('payment-modal-wrapper')

type PaymentModalWrapperProps = {
  children: React.ReactChild
  path: string
  paymentType: PaymentTypesType
}

export const PaymentModalWrapper: React.FC<PaymentModalWrapperProps> = ({ children, path, paymentType }) => {
  const { closeModal, replaceLastModal } = useModalContext()

  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
  const locale = useSelector(selectLocaleDict, shallowEqual).payment

  const onCloseModal = useCallback(() => {
    closeModal(path)()
  }, [closeModal, path])

  useEffect(() => {
    if (!isAuth) {
      onCloseModal()
    }
  }, [isAuth])

  if (!isAuth) return null

  return (
    <div className={b()}>
      <div className={b('header')}>
        <div className={b('header-logo')}>
          <LogoSVG className={b('logo')} />
        </div>
        <button onClick={closeModal(path)} type="button" className={b('header-close')}>
          <div className={b('header-close-icon')}>×</div>
        </button>
      </div>
      <div className={b('navigation')}>
        <div
          className={b('navigation-item', { isActive: paymentType === PaymentTypes.DEPOSIT })}
          onClick={replaceLastModal(MODAL_ROUTE_URLS.DEPOSIT())}>
          {locale.deposit}
        </div>
        <div
          className={b('navigation-item', { isActive: paymentType === PaymentTypes.PAYOUT })}
          onClick={replaceLastModal(MODAL_ROUTE_URLS.WITHDRAWAL())}>
          {locale.withdraw}
        </div>
      </div>
      {children}
    </div>
  )
}
